<template>
  <div id="listapre">
    <b-jumbotron>
      <loading :active.sync="showloading" :is-full-page="true"></loading>
    <h3>
      Lista Pré-Matriculados
    </h3>
    
    <hr class="my-4">

    
    <b-list-group v-for="(escola, index) in prematriculas" :key="escola.id" style="padding-bottom: 10px;">
      <b-list-group-item align="left"> 
        <b-alert variant="success" show> <h5> Escola: {{ escola.nome }}</h5> </b-alert>

        <div role="tablist">
          <b-card no-body class="mb-1" v-for="(nivel, index) in escola.nivelescolar" :key="nivel.id">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block href="#" @click="abrir(nivel.id)" variant="info"> {{ nivel.descricao }} - Qtde Alunos: {{ nivel.qtdealunos }}</b-button>
            </b-card-header>
            <b-collapse :id="'acc' + nivel.id" visible accordion="my-accordion" role="tabpanel">
              <b-card-body v-if="nivel.alunos ? nivel.alunos.length > 0 ? true : false : false">
                <b-card-text>
                    <table class="table">
                      <div class="row">
                        <div class="col-lg-12 m-0 pt-0 pr-0 pl-0 pb-0">
                          <div class="d-flex alert alert-primary text-muted justify-content-center font-weight-bold p-2 m-0" role="alert" style="font-size: 18px; ">
                            Aluno(s)
                          </div>
                        </div>
                      </div>
                      <tbody>
                        <tr class="row" v-for="(aluno, index) in nivel.alunos" :key="aluno.id">
                            <td class="col-lg-12 m-0 pt-2 pr-0 pl-0 pb-0">
                              <div class="alert alert-secondary text-muted h-100 align-middle font-weight-bold p-0 m-0" role="alert" style="font-size: 18px; ">
                                <p class="m-0 p-0"><span class="font-weight-bold"> {{ aluno.nomealuno }} </span></p>
                                <strong class="text-primary m-0 p-0" style="font-size: 13px;"> Responsável: </strong> <span class="m-0 p-0" style="font-size: 13px;"> {{ aluno.nomeresp }} - {{ aluno.fonecelular | telefone }} </span>
                              </div>
                            </td>  
                        </tr>        
                      </tbody>
                    </table>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

        </div>


      </b-list-group-item> 
    </b-list-group>
    
  </b-jumbotron>
  </div>
</template>

<script>

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  name: "listaPreMatricula",
  components: {
    Loading
  },
  data () {
    return {
      prematriculas: '',
      erros: '',
      showloading: false,
    }
  },
  beforeCreate () {
    this.prematriculas = [{nomealuno: 'jefe', nomeresp: 'teste', nome: 'escola', descricao: ''}]
  },
  created () {
    this.buscaPreMatriculas()
  },
  methods: {
    buscaPreMatriculas () {
      this.showloading = true
      this.$http.get(this.urlAPI + 'prematricula', {})
      .then(response => {
        if (response.data.status) {
          this.prematriculas = response.data.prematriculas
        } else if (response.data.status === false && response.data.validacao) {
          let erros = ''
          let obj = response.data.erros
          if (Object.keys(obj).length) {
            Object.keys(obj).forEach(function (item) {
              erros += obj[item] + ', '
            })
            this.erros = erros
          }
        }
      })
      .catch(e => {
        alert('Erro! Tente novamente mais tarde...')
      })
      .finally(() => this.showloading = false)
    },
    abrir (item) {
      this.$root.$emit('bv::toggle::collapse', 'acc'+item)
    }
  },
  filters: {
    telefone: function (fone) {
      fone=fone.replace(/\D/g,"");             //Remove tudo o que não é dígito
      fone=fone.replace(/^(\d{2})(\d)/g,"($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
      fone=fone.replace(/(\d)(\d{4})$/,"$1-$2");    //Coloca hífen entre o quarto e o quinto dígitos
      return fone;
    }
  }
};
</script>

<style>

  #listapre .btn-info {
    color: #fff !important;
  }

  @media (max-width: 991.98px) { 
    #listapre .esconder-mobile {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/listaprematricula.vue